__turbopack_context__.v({
  "canvas": "ArchitectedBlueprint-module__ZOXjuq__canvas",
  "centerCore": "ArchitectedBlueprint-module__ZOXjuq__centerCore",
  "coreInner": "ArchitectedBlueprint-module__ZOXjuq__coreInner",
  "fw-bold": "ArchitectedBlueprint-module__ZOXjuq__fw-bold",
  "headerWrap": "ArchitectedBlueprint-module__ZOXjuq__headerWrap",
  "info": "ArchitectedBlueprint-module__ZOXjuq__info",
  "info-fade": "ArchitectedBlueprint-module__ZOXjuq__info-fade",
  "infoDesc": "ArchitectedBlueprint-module__ZOXjuq__infoDesc",
  "infoEnter": "ArchitectedBlueprint-module__ZOXjuq__infoEnter",
  "infoTechList": "ArchitectedBlueprint-module__ZOXjuq__infoTechList",
  "infoTechTitle": "ArchitectedBlueprint-module__ZOXjuq__infoTechTitle",
  "infoTitle": "ArchitectedBlueprint-module__ZOXjuq__infoTitle",
  "lineActive": "ArchitectedBlueprint-module__ZOXjuq__lineActive",
  "lines": "ArchitectedBlueprint-module__ZOXjuq__lines",
  "node": "ArchitectedBlueprint-module__ZOXjuq__node",
  "nodeActive": "ArchitectedBlueprint-module__ZOXjuq__nodeActive",
  "nodeLabel": "ArchitectedBlueprint-module__ZOXjuq__nodeLabel",
  "placeholder": "ArchitectedBlueprint-module__ZOXjuq__placeholder",
  "pos1": "ArchitectedBlueprint-module__ZOXjuq__pos1",
  "pos2": "ArchitectedBlueprint-module__ZOXjuq__pos2",
  "pos3": "ArchitectedBlueprint-module__ZOXjuq__pos3",
  "pos4": "ArchitectedBlueprint-module__ZOXjuq__pos4",
  "section": "ArchitectedBlueprint-module__ZOXjuq__section",
  "small": "ArchitectedBlueprint-module__ZOXjuq__small",
  "text-muted": "ArchitectedBlueprint-module__ZOXjuq__text-muted",
  "text-uppercase": "ArchitectedBlueprint-module__ZOXjuq__text-uppercase",
});
